// helpers
import { format, trimString, isEmpty } from './utils';
import { CLOUDINARY_BASE_PARAMS, CLOUDINARY_VIDEO_BASE_PARAMS, IMAGEKIT_BASE_URL, } from '@/constants/cloudinary';
export function getCloudinaryUrl(filename, options = {}, addCacheParam = false, updateDaily = false) {
    if (isEmpty(filename)) {
        return '';
    }
    filename = trimString(filename);
    const params = [...CLOUDINARY_BASE_PARAMS];
    Object.keys(options).forEach((key) => {
        switch (key) {
            case 'progressive':
                if (options.progressive === true) {
                    params.push('fl_progressive');
                }
                break;
            case 'transparent':
                if (options.transparent === true) {
                    params.push('e_make_transparent');
                }
                break;
            case 'width':
                if (options.width > 0) {
                    params.push(`w_${options.width}`);
                }
                break;
            case 'height':
                if (options.height > 0) {
                    params.push(`h_${options.height}`);
                }
                break;
            case 'sharpen':
                if (options.sharpen > 0) {
                    params.push(`e_sharpen:${options.sharpen}`);
                }
                break;
            case 'centerScale':
                if (options.centerScale === true) {
                    params.push('c_scale');
                }
                break;
            case 'centerCrop':
                if (options.centerCrop === true) {
                    params.push('c_crop');
                }
                break;
            case 'trim':
                if (options.trim === true) {
                    params.push('e_trim');
                }
                break;
            case 'grayscale':
                if (options.grayscale === true) {
                    params.push('e_grayscale');
                }
                break;
            case 'fill':
                if (options.fill === true) {
                    params.push('c_fill');
                }
                break;
            case 'fit':
                if (options.fit === true) {
                    params.push('c_fit');
                }
                break;
        }
    });
    return getFormattedCloudinaryUrl({
        addCacheParam,
        filename,
        options,
        params,
        updateDaily,
        url: IMAGEKIT_BASE_URL,
    });
}
export function getVideoCloudinaryUrl(filename, options = {}, addCacheParam = false) {
    if (isEmpty(filename)) {
        return '';
    }
    filename = trimString(filename);
    const params = [...CLOUDINARY_VIDEO_BASE_PARAMS];
    Object.keys(options).forEach((key) => {
        switch (key) {
            case 'width':
                if (options.width > 0) {
                    params.push(`w_${options.width}`);
                }
                break;
            case 'height':
                if (options.height > 0) {
                    params.push(`h_${options.height}`);
                }
                break;
            case 'centerScale':
                if (options.centerScale === true) {
                    params.push('c_scale');
                }
                break;
            case 'centerCrop':
                if (options.centerCrop === true) {
                    params.push('c_crop');
                }
                break;
            case 'fill':
                if (options.fill === true) {
                    params.push('c_fill');
                }
                break;
            case 'so':
                if (Number(options.so) > 0) {
                    params.push(`so_${options.so}`);
                }
                break;
            case 'quality':
                if (Number(options.quality) > 0) {
                    params.push(`q_${options.quality}`);
                }
                break;
        }
    });
    return getFormattedCloudinaryUrl({
        addCacheParam,
        filename,
        options,
        params,
        url: IMAGEKIT_BASE_URL,
    });
}
const date = new Date();
const today = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
const todayHour = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours()).getTime();
const todayMinute = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes()).getTime();
export function getCloudinaryRawUrl(filename, options = {
    keepExtension: true,
    cache: false,
}, isMinuteCacheBurst = false) {
    if (isEmpty(filename)) {
        return '';
    }
    filename = trimString(filename);
    const todayTime = isMinuteCacheBurst ? todayMinute : todayHour;
    const fName = options.cache ? `v${todayTime}/${filename}` : filename;
    const params = [];
    return getFormattedCloudinaryUrl({
        filename: fName,
        url: IMAGEKIT_BASE_URL,
        params,
        options,
    });
}
function getFormattedCloudinaryUrl({ filename, url, params, options, addCacheParam, updateDaily, }) {
    // remove extension from the filename
    if (!options.keepExtension && filename.indexOf('.') !== -1) {
        filename = filename.split('.').slice(0, -1).join('.');
    }
    if (updateDaily) {
        filename = `v${today}/${filename}`;
    }
    const formattedUrl = format('{0}/{1}/{2}', url, params.join(','), filename);
    if (addCacheParam) {
        return (formattedUrl +
            (formattedUrl.indexOf('?') === -1
                ? '?_cacheAsset=1'
                : '&_cacheAsset=1'));
    }
    return formattedUrl;
}
